export default function Billings() {
    return (
        <div>
            <h2>Billings</h2>
        </div>
    )
}
